module.exports = __webpack_public_path__ + "img/1O.0220d0a3.jpg";